import type { MuscleInfo } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const muscleAdapter = createEntityAdapter<MuscleInfo>();
const muscleSlice = createSlice({
	name: 'entities/muscle',
	initialState: muscleAdapter.getInitialState(),
	reducers: {
		setAll: muscleAdapter.setAll,
	},
});
type MuscleSliceState = ReturnType<typeof muscleAdapter.getInitialState>;

const muscleSliceActions = { ...muscleSlice.actions };
const muscleSliceReducer = muscleSlice.reducer;

export { muscleSliceActions, muscleSliceReducer, muscleAdapter };
export type { MuscleSliceState };
